<template>
    <div
        class="employ"
        id="employ"
    >
        <div
            v-if="preview"
            class="time"
        >
            距报名开始 <span>{{ data.d }}</span>天<span>{{ data.h }}</span> 时 <span>{{ data.m }}</span>分 <span>{{ data.s }}</span>秒
            <p style="position: absolute; top: 0px; right: 15px">
                报名时间：{{ timestampToTime(time) }}
            </p>
        </div>
        <el-tabs
            class="main_tabs"
            v-model="activeName"
            type="card"
        >
            <el-tab-pane
                name="chooseclass"
                label="选择班级"
                :lazy="true"
            >
                <div
                    class="button-row mb10"
                    style="font-size: 16px"
                >
                    当前筛选：
                    <el-tag
                        v-for="tag in tags"
                        :key="tag.name"
                        closable
                        :disable-transitions="true"
                        @close="handleClose(tag)"
                        :type="tag.type"
                    >
                        {{ tag.name }}
                    </el-tag>
                    <el-input
                        v-model="query.scName"
                        class="w200 right"
                        placeholder="请输入您要选择的班级"
                        clearable
                        @change="handleQuery"
                        @keyup.enter.native="handleQuery(name)"
                    ><i
                            slot="suffix"
                            class="el-input__icon el-icon-search"
                        ></i></el-input>
                </div>
                <el-form
                    ref="form"
                    class="formarea"
                >
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item
                                label="校区:"
                                prop="name"
                                style="font-size: 24px"
                                label-width="96px"
                            >
                                <el-radio-group
                                    v-model="query.campusId"
                                    @change="perChange1"
                                >
                                    <el-radio-button
                                        v-for="(
                                            item, index
                                        ) in dictionary.campusData"
                                        :label="item.id"
                                        :key="index"
                                    >{{ item.name }}</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row
                        :gutter="10"
                        v-if="dictionary.campusData.length > 0"
                    >
                        <el-col :span="24">
                            <el-form-item
                                label="系/专业:"
                                prop="name"
                                style="font-size: 24px"
                                label-width="96px"
                            >
                                <el-radio-group
                                    v-model="query.specialtyId"
                                    @change="perChange2"
                                >
                                    <el-radio-button
                                        v-for="(
                                            item, index
                                        ) in dictionary.majorData"
                                        :label="item.id"
                                        :key="index"
                                    >{{ item.name }}</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row
                        :gutter="10"
                        v-if="dictionary.courseData.length > 0"
                    >
                        <el-col :span="24">
                            <el-form-item
                                label="课程:"
                                prop="name"
                                style="font-size: 24px"
                                label-width="96px"
                            >
                                <el-radio-group
                                    v-model="query.courseId"
                                    @change="perChange3"
                                >
                                    <el-radio-button
                                        v-for="(
                                            item, index
                                        ) in dictionary.courseData"
                                        :label="item.id"
                                        :key="index"
                                    >{{ item.name }}</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item
                                label="上课时间:"
                                prop="name"
                                style="font-size: 24px"
                                label-width="96px"
                            >
                                <el-radio-group
                                    v-model="query.week"
                                    @change="perChange4"
                                >
                                    <el-radio-button
                                        v-for="(item, index) in week"
                                        :label="item.id"
                                        :key="index"
                                    >{{ item.name }}</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row
                        :gutter="10"
                        v-if="newAndOld"
                    >
                        <el-col :span="24">
                            <el-form-item
                                label="新老班:"
                                prop="name"
                                style="font-size: 24px"
                                label-width="96px"
                            >
                                <el-radio-group
                                    v-model="query.newFlag"
                                    @change="perChange5"
                                >
                                    <el-radio-button
                                        v-for="(item, index) in classes"
                                        :label="item.id"
                                        :key="index"
                                    >{{ item.name }}</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="chooseClass">
                    <div class="c-title">
                        <span class="b"></span>
                        <div>选择就读班级</div>
                    </div>
                    <div style="position: relative">
                        <el-radio-group
                            v-model="isNew"
                            @change="perChange6"
                        >
                            <el-radio-button
                                v-for="(item, index) in classtype"
                                :label="item.id"
                                :key="index"
                            >{{ item.name }}</el-radio-button>
                        </el-radio-group>
                        <div class="ranum">{{ chooseClassData.length }}</div>
                    </div>
                </div>
                <el-table
                    :data="tableData"
                    ref="dataTable"
                    @row-click="rowClick"
                    v-loading="loading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <el-table-column
                        label="班级"
                        prop="name"
                        min-width="120px"
                    >
                        <template slot-scope="scope">
                            <a @click="viewJob(scope.row)">{{
                                scope.row.name
                            }}</a>
                            <span
                                v-if="scope.row.shortTraining"
                                style="color: #e4393c; font-size: 14px"
                            >(短训班)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="上课时间"
                        prop="periodNames"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.shortTraining">
                                <el-tooltip
                                    :content="scope.row.periodNames"
                                    placement="right"
                                >
                                    <span>{{ scope.row.shortTrainingStart }}到{{
                                            scope.row.shortTrainingEnd
                                        }}</span>
                                </el-tooltip>
                            </span>
                            <span v-else>{{ scope.row.periodNames }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="教师"
                        prop="teacherNames"
                    ></el-table-column>
                    <el-table-column
                        label="人数"
                        prop="studentNumberPlan"
                        min-width="50px"
                    >
                        <template slot-scope="scope">
                            <span 
                                style="color:#6a707c" 
                                v-if="scope.row.isFull"
                            >已满</span>
                            <span
                                v-else-if="!scope.row.isFull && !isShowDetail"
                                class="c-w-color"
                            >未满</span>
                            <span
                                v-else
                                class="c-s-color"
                            >剩{{
                                    scope.row.studentNumberPlan -
                                    scope.row.studentNumberReg
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!feeclsoneSwitch"
                        label="学费/元"
                        prop="fee"
                        min-width="50px"
                    ></el-table-column>
                    <el-table-column
                        label="学费类型"
                        prop="fee"
                        min-width="80px"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.feeUnit == '1'"> 年 </span>
                            <span v-else-if="scope.row.feeUnit == '2'">
                                学期
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="材料费/元"
                        prop="materialCost"
                        min-width="50px"
                        v-if="ismast"
                    ></el-table-column>
                    <el-table-column
                        label="报名费/元"
                        prop="allClassFee"
                        min-width="50px"
                        v-if="isbm"
                    ></el-table-column>
                    <el-table-column label="说明">
                        <template slot-scope="scope">
                            <span v-if="scope.row.auditionTips">
                                {{ scope.row.auditionTips }}
                            </span>
                            <span v-else-if="scope.row.chooseTips">
                                {{ scope.row.chooseTips }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        min-width="160px"
                    >
                        <template slot-scope="scope">
                            <div v-if="preview">
                                <el-button
                                    size="mini"
                                    @click="intro(scope.row)"
                                >查看介绍</el-button>
                            </div>
                            <div v-else-if="scope.row.isFull">
                                <el-button
                                    size="mini"
                                    @click="intro(scope.row)"
                                >查看介绍</el-button>
                            </div>
                            <div v-else>
                                <el-button
                                    size="mini"
                                    v-if="scope.row.selecte"
                                    type="danger"
                                    @click="cancel(scope.row)"
                                >
                                    取消</el-button>
                                <el-button
                                    size="mini"
                                    @click="chooseClass(scope.row)"
                                    v-if="
                                        scope.row.chooseTips == undefined &&
                                        scope.row.auditionTips == undefined &&
                                        !scope.row.isFull &&
                                        !scope.row.selecte
                                    "
                                >选择班级</el-button>
                                <el-button
                                    size="mini"
                                    @click="intro(scope.row)"
                                >查看介绍</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="register-footer">
                    <div>
                        已选择<span class="num">{{
                            chooseClassData.length
                        }}</span>个
                        <el-button
                            type="warning"
                            @click="register"
                        >立即报名</el-button>
                    </div>
                </div>
                <div
                    class="wrap_footer clearfix"
                    style="margin-bottom: 20px"
                >
                    <!-- <div class="left">
        <el-button @click="exportExcel()" size="small">导出表单</el-button>
      </div> -->
                    <div class="right">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="query.pageIndex"
                            :page-sizes="[5, 10, 15, 20]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        >
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
            :title="classname"
            :visible.sync="dialogVisible"
            width="30%"
            @close="handleCloseS"
        >
            <span>{{ content }}</span>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment-timezone";
export default {
    name: "Chooseclass",

    data() {
        return {
            loading: false,
            activeName: "chooseclass",
            tabIndex: "0",
            dialogVisible: false,
            content: "",
            classname: "",
            ismast: false,
            isbm: false,
            newAndOld: false,
            query: {
                type: "5",
                campusId: "",
                scName: "",
                planType: "1",
                specialtyId: "",
                courseId: "",
                week: "",
                newFlag: "",
                pageIndex: 1,
                pageSize: 5,
            },
            pageSize: 5,
            iscostmateries: false,
            isallClassFee: false,
            planId: "",
            dictionary: {
                courseData: [],
                majorData: [],
                campusData: [],
                classtype: [],
            },
            chooseClassData: [],
            week: [
                { name: "周一", id: "1" },
                { name: "周二", id: "2" },
                { name: "周三", id: "3" },
                { name: "周四", id: "4" },
                { name: "周五", id: "5" },
                { name: "周六", id: "6" },
                { name: "周日", id: "7" },
            ],
            classes: [
                { name: "新班", id: true },
                { name: "老班", id: false },
            ],
            classtype: [
                {
                    name: "全部",
                    id: "0",
                },
                {
                    name: "在招班级",
                    id: "1",
                },
                {
                    name: "已选班级",
                    id: "2",
                },
            ],
            tags: [],
            detailData: [],
            timer: null,
            // 数据相关
            tableData: [],
            selectedData: [],
            typeitem: "0",
            isNew: 0,
            total: 0,
            sclass: [],
            isinit: true,
            time: "",
            preview: false,
            data: {
                d: "",
                h: "",
                m: "",
                s: "",
            },
            choosequery: {
                termId: "",
                sclass: "",
                classId: "",
                planId: "",
            },
            feeclsoneSwitch: false,
            isShowDetail:true,
        };
    },
    mounted() {
        this.isinit = true;
        this.query = {
            type: "1",
            campusId: "",
            scName: "",
            planType: "1",
            specialtyId: "",
            courseId: "",
            week: "",
            newFlag: "",
            pageIndex: 1,
            pageSize: 5,
        };
        this.select();
        //  this.getDictionary();
    },
    created() {
        this.$global.activeMenu = "2-2";
    },
    methods: {
        countTime: function () {
            let me = this;
            var nowdate = new Date();
            var now = nowdate.getTime();
            var leftTime = "";
            leftTime = me.time - now;
            var d, h, m, s;
            if (leftTime >= 0) {
                d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
                m = Math.floor((leftTime / 1000 / 60) % 60);
                s = Math.floor((leftTime / 1000) % 60);
                if (d < 10) {
                    d = "0" + d;
                }
                if (h < 10) {
                    h = "0" + h;
                }
                if (m < 10) {
                    m = "0" + m;
                }
                if (s < 10) {
                    s = "0" + s;
                }
                me.data.d = d;
                me.data.h = h;
                me.data.m = m;
                me.data.s = s;
            } else {
                clearInterval(me.timer);
                me.timer = null;
                me.preview = false;
            }
        },
        handleCloseS() {
            this.dialogVisible = false;
        },
        intro(row) {
            if (row.introduction) {
                this.classname = row.name;
                this.content = row.introduction;
            } else {
                this.classname = "提示";
                this.content = "暂无介绍";
            }
            this.dialogVisible = true;
        },
        perChange6(item) {
            this.typeitem = item;
            if (item == "1") {
                this.select();
            } else if (item == "2") {
                this.select();
            } else if (item == "0") {
                this.select();
            }
        },
        cancel(row) {
            let me = this;
            row.selecte = false;
            this.chooseClassData.forEach(function (obj, index) {
                if (obj.id == row.id) {
                    me.chooseClassData.splice(index, 1);
                    me.sclass.splice(index, 1);
                }
            });
            if (this.typeitem == "2") {
                me.tableData = me.chooseClassData;
            }
        },
        chooseClass(row) {
            if (this.chooseClassData.length > 0) {
                this.choosequery.sclass = this.sclass.join(",");
            }
            this.choosequery.classId = row.id;

            this.checkCanSignUp(row);
        },
        selectable(row, index) {
            if (!row.isFull) {
                return true;
            } else {
                return false;
            }
        },
        isfull(row) {
            if (row.isFull == null || !row.isFull) {
                if (row.studentNumberPlan - row.studentNumberReg > 0) {
                    let num =
                        (row.studentNumberPlan -
                            row.reserve -
                            row.studentNumberReg) /
                        row.studentNumberPlan;
                    if (parseFloat(num) >= 0.3) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }
        },
        getLengthText(type, obj) {
            this.obj = false;
            for (let k = 0; k < this.tableData.length; k++) {
                if (this.tableData[k].type != null) {
                    this.obj = true;
                }
            }
        },
        async checkCanSignUp(row) {
            let me = this;
            this.loading = true;
            let param = {};
            param = me.choosequery;
            let res = await me.$userService.checkCanSignUp(param);
            if (res && res.success) {
                if (res.content.isPass) {
                    me.chooseClassData.push(row);
                    me.sclass.push(row.id);
                    row.selecte = true;
                } else {
                    me.$message({
                        message: res.content.msg,
                        type: "warning",
                    });
                    this.loading = false;
                }
                this.loading = false;
            } else {
                this.loading = false;
            }
        },
        async select() {
            let me = this;
            let param = me.query;
            let temData = [],
                intemData = [];
            let res = await me.$userService.select(param);
            if (res && res["success"]) {
                me.isShowDetail = res.content.isShowDetail;
                me.feeclsoneSwitch = res.content.feeclsoneSwitch;
                if (param.type == "1") {
                    me.newAndOld = res.content.newAndOld;
                    me.dictionary.campusData = res.content.data;
                    if (me.isinit) {
                        me.query.campusId = res.content.campusId;
                        me.tags.push({
                            name: me.dictionary.campusData[0].name,
                            type: "",
                            code: "1",
                            id: this.dictionary.campusData[0].id,
                        });
                    }
                    me.choosequery.termId = res.content.term.id;
                    me.query.type = "3";
                    me.select();
                    me.isinit = false;
                } else if (param.type == "3") {
                    me.dictionary.majorData = res.content.data;
                    me.dictionary.courseData = [];
                    me.query.type = "5";
                    me.select();
                } else if (param.type == "4") {
                    me.dictionary.courseData = res.content.data;
                    me.query.type = "5";
                    me.select();
                } else if (param.type == "5") {
                    me.isbm = false;
                    me.ismast = false;
                    for (let i = 0; i < res.content.data.records.length; i++) {
                        res.content.data.records[i].selecte = false;
                        if (res.content.data.records[i].allClassFee) {
                            me.isbm = true;
                        }
                        res.content.data.records[i].materialCost =
                            res.content.data.records[i].materialCost || 0;
                        if (res.content.data.records[i].materialCost > 0) {
                            me.ismast = true;
                        }
                        if (me.chooseClassData.length > 0) {
                            for (
                                let k = 0;
                                k < me.chooseClassData.length;
                                k++
                            ) {
                                if (
                                    res.content.data.records[i].id ==
                                    me.chooseClassData[k].id
                                ) {
                                    res.content.data.records[i].selecte = true;
                                    temData.push(res.content.data.records[i]);
                                }
                            }
                        }
                        if (!res.content.data.records[i].isFull) {
                            intemData.push(res.content.data.records[i]);
                        }
                    }
                    if (this.typeitem == "0") {
                        me.tableData = res.content.data.records;
                        me.total = res.content.data.total;
                    } else if (this.typeitem == "2") {
                        me.tableData = temData;
                        me.total = me.tableData.length;
                    } else if (this.typeitem == "1") {
                        me.tableData = intemData;
                        me.total = me.tableData.length;
                    }

                    me.query.pageIndex = res.content.data.page;
                    me.planId = res.content.planId;
                    me.preview = res.content.preview;
                    me.choosequery.planId = res.content.planId;
                    if (me.preview) {
                        me.timer = setInterval(function () {
                            me.countTime();
                        }, 1000);
                    }
                    me.time = res.content.startTime;
                }
            }
        },
        timestampToTime: function (timestamp) {
            let timestamps = parseInt(timestamp);
            var date = new Date(timestamps); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + "-";
            var M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
            var D = date.getDate() + " ";
            var h =
                (date.getHours() < 10
                    ? "0" + date.getHours()
                    : date.getMonth() + 1) + ":";
            var m =
                (date.getMinutes() < 10
                    ? "0" + date.getMinutes()
                    : date.getMinutes() + 1) + ":";
            var s =
                date.getSeconds() < 10
                    ? "0" + date.getSeconds()
                    : date.getSeconds() + 1;
            return Y + M + D + h + m + s;
        },
        // 普通搜索
        handleQuery() {
            this.select();
        },
        async register() {
            let param = {},
                me = this;
            if (this.sclass.length > 0) {
                param.sclass = this.sclass;
                param.planId = me.planId;
                let re = await me.$userService.saveClass(param);
                if (re && re.success) {
                    me.$message({
                        message: re.content.msg,
                        type: "success",
                        duration: 800,
                        onClose: function () {
                            if (re.content.datas.length > 0) {
                                me.$router.push({
                                    name: "Pay",
                                });
                            }
                        },
                    });
                }
            } else {
                me.$message({
                    message: "请选择班级",
                    type: "error",
                });
            }
        },
        handleClose(tag) {
            this.tags.splice(this.tags.indexOf(tag), this.tags.length);
            if (tag.code == "1") {
                this.query = {
                    type: "1",
                    campusId: "",
                    scName: "",
                    specialtyId: "",
                    courseId: "",
                    week: "",
                    newFlag: "",
                    planType: "1",
                    pageIndex: 1,
                    pageSize: 5,
                };
                this.tableData = [];
                //  this.select();
                this.dictionary.majorData = [];
                this.dictionary.courseData = [];
            } else if (tag.code == "2") {
                this.query.type = "3";
                this.query.courseId = "";
                this.query.specialtyId = "";
                this.query.week = "";
                this.query.newFlag = "";
                this.dictionary.courseData = [];
                this.select();
            } else if (tag.code == "3") {
                this.query.type = "4";
                this.query.courseId = "";
                this.query.week = "";
                this.query.newFlag = "";
                this.select();
            } else if (tag.code == "4") {
                this.query.week = "";
                this.query.newFlag = "";
                this.select();
            } else if (tag.code == "5") {
                this.query.newFlag = "";
                this.select();
            }
        },
        delRepeat(arr) {
            //数组对象去重
            return Object.values(
                arr.reduce((obj, next) => {
                    var key = JSON.stringify(next);
                    return (obj[key] = next), obj;
                }, {})
            );
        },
        tagschange(target, item, type) {
            for (var i = 0; i < target.length; i++) {
                for (var j = 0; j < this.tags.length; j++) {
                    if (this.tags[j].name == target[i].name) {
                        this.tags.splice(j, 1);
                        j = j - 1;
                    }
                }
                if (target[i].id == item) {
                    this.tags.splice(type, this.tags.length);

                    this.tags.splice(type, 0, {
                        name: target[i].name,
                        type: "",
                        code: type + 1,
                        id: target[i].id,
                    });
                }
            }
            if (type == "0") {
                this.query.specialtyId = "";
                this.query.courseId = "";
                this.query.type = "3";
                this.query.week = null;
            }
            if (type == "1") {
                this.query.type = "4";
                this.query.week = null;
                this.query.courseId = "";
            }
            if (type == "2") {
                this.query.type = "5";
                this.query.week = null;
            }
            this.select();
        },
        perChange1(item) {
            this.tagschange(this.dictionary.campusData, item, 0);
        },
        perChange2(item) {
            this.tagschange(this.dictionary.majorData, item, 1);
        },
        perChange3(item) {
            this.tagschange(this.dictionary.courseData, item, 2);
        },
        perChange4(item) {
            this.tagschange(this.week, item, 3);
        },
        perChange5(item) {
            this.tagschange(this.classes, item, 4);
        },

        choosetype(item) {
            console.log(item);
        },
        // 处理每页显示数量
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.select();
        },
        // 处理翻页
        handleCurrentChange(val) {
            this.query.pageIndex = val;
            this.select();
        },
        // 处理表格勾选
        handleSelectionChange(value) {
            this.selectedData = value;
        },
        rowClick(row) {
            this.$refs.dataTable.toggleRowSelection(row);
        },

        formatDate(date, format = "YYYY-MM-DD") {
            if (date === undefined || date === "" || date === null) {
                return "";
            }
            return moment(date).format(format);
        },
    },
    created() {},
    watch: {
        // detailData() {
        //   let tempArr = Object.assign([], this.detailData)
        //   tempArr = this.delRepeat(tempArr)
        //   this.tags = tempArr
        // },
    },
};
</script>
<style lang="scss" >
#employ {
    .time {
        font-size: 20px;
        text-align: center;
        margin: 10px 0;
        position: relative;
        span {
            color: #ff8d3c;
        }
    }
    .el-tag {
        margin: 0 10px;
    }
    span {
        cursor: pointer;
    }
    .c-w-color {
        color: #1989fa;
    }
    .c-s-color {
        color: #ff0000;
    }
    .c-c-color2 {
        background: #1989fa;
        color: #fff;
        padding: 3px 3px;
    }
    .ranum {
        position: absolute;
        top: -8px;
        left: 250px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        overflow: hidden;
        text-align: center;
        line-height: 20px;
        color: #fff;
        background: red;
    }
    .register-footer {
        padding: 10px 30px;
        border: 1px solid #ebeef5;
        border-top: none;
        overflow: hidden;
        div {
            float: right;
            font-size: 18px;
            span.num {
                color: #ff8d3c;
            }
            .el-button--warning {
                margin-left: 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/register/children/chooseclass.vue